import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { EditorShowSpecialFieldsEventProps } from '@dev/template-editor';
import { ShowDialogParams } from '@/store/dialog/types';
import { UpdateDialog } from '@/store/dialog/actions';
import { SpecialFieldToInsert } from '@/services/hooks/useEmailTemplateSpecialFields/types';
import { SpecialFieldsModal } from '../components/SpecialFieldsModal';

export const useSpecialFieldsModalParams = (): {
    getSpecialFieldsModalParams: (props: EditorShowSpecialFieldsEventProps) => ShowDialogParams;
} => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const fieldToInsert = useRef<SpecialFieldToInsert>();

    const getSpecialFieldsModalParams = (props: EditorShowSpecialFieldsEventProps): ShowDialogParams => {
        const isButton = props.contentRef.current.tagName === 'A';
        fieldToInsert.current = null;
        const onSaveClick = (): void => {
            if (!fieldToInsert.current) {
                props.onClose();
                return;
            }
            if (fieldToInsert.current.isAdditonalValueEmptyButRequired || !fieldToInsert.current.isValid) {
                dispatch(UpdateDialog({
                    body: <SpecialFieldsModal onChange={onChange} defaultField={{
                        value: fieldToInsert.current.value,
                        fullValue: fieldToInsert.current.fullValue
                    }} isError={true} isButton={isButton}/>,
                    isDisabled: true
                }));
                return;
            }
            const valueToInsert = fieldToInsert.current.textValue || { value: fieldToInsert.current.value, fullValue: fieldToInsert.current.fullValue };
            props.onFieldInsert(valueToInsert);
            props.onClose();
        };

        const onChange = (field: SpecialFieldToInsert): void => {
            fieldToInsert.current = field;

            dispatch(UpdateDialog({
                body: <SpecialFieldsModal onChange={onChange} defaultField={{
                    value: fieldToInsert.current.value,
                    fullValue: fieldToInsert.current.fullValue
                }} isError={!fieldToInsert.current.isValid} isButton={isButton}/>,
                isDisabled: field.isAdditonalValueEmptyButRequired || !fieldToInsert.current.isValid
            }));
        };

        const body = (
            <SpecialFieldsModal onChange={onChange} defaultField={props.selectedField} isError={false} isButton={isButton}/>
        );

        return {
            title: t('addmergefields'),
            confirmLabel: t('save'),
            onClickConfirm: onSaveClick,
            cancelLabel: t('cancel'),
            onClickCancel: props.onClose,
            body,
            id: 'specialfields-modal',
            isHiddenManually: true,
        };
    };
    return { getSpecialFieldsModalParams };
};
